import { IPriceList } from "../type/IPriceList";
import { IShoppingCartItems } from "../type/IShoppingCartItems";
import { formatPrice } from "./formatPrice";

export const formatTotal = (items: IShoppingCartItems[], priceList: IPriceList): string => {
  const totalNum = items.reduce((prev, item) => {
    return prev + Number(priceList[item.product.id]?.price || 0) * item.qty;
  }, 0);
  return formatPrice(totalNum.toString());
}